module.exports = __webpack_public_path__ + "static/img/Registrobr1.3a4597b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faq/Registrobr1.gif
// module id = 1768
// module chunks = 5